import { Injectable } from '@angular/core';
// import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { switchMap, tap, retryWhen } from 'rxjs/operators';
import { UserInterface } from '../models';
import { UserService, UserModel } from '../user';
import { RoleService } from './role.service';
import { LogInInterface, LogInResponseInterface } from '../interfaces';
import jwt_decode from 'jwt-decode';
import { plainToClass } from 'class-transformer';


@Injectable({
  providedIn: 'root',
})
export class AuthService {

  private _user: UserModel;

  constructor(private http: HttpClient,
              private userService: UserService,
              private roleService: RoleService) {
    const userString = localStorage.getItem('currentUser');
    if (userString !== null) {
      const data: LogInResponseInterface = JSON.parse(userString);
      this._initUser(data).subscribe();
    }
  }

  login(data: LogInInterface): Observable<UserModel> {
    return this.http.post<LogInResponseInterface>('/auth/login', data).pipe(
      switchMap(user => this._initUser(user))
    );
  }

  private _initUser(data: LogInResponseInterface): Observable<UserModel> {
    if (data && data.token) {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      const jwtPayload = jwt_decode(data.token);
      localStorage.setItem('currentToken', JSON.stringify(jwtPayload));
      localStorage.setItem('currentUser', JSON.stringify(data));
      return this.userService.get(data.user._id).pipe(
        tap(user => { this._user = user; })
      );
    } else {
      return of(plainToClass(UserModel, data.user));
    }
  }

  public getUser(): UserModel {
      return this._user || new UserModel();
  }

  logout(): void {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    localStorage.removeItem('currentToken');
    // localStorage.removeItem('user');
    // this.router.navigate(['/login']);
  }
}
